import React from "react";

export const affixStyle: React.CSSProperties = {
  width: 290,
  overflowY: "auto",
  background: "#1e1e1e",
  borderLeft: "1px solid #333",
};

export const affixPosition: React.CSSProperties = {
  right: 0,
  top: 0,
  bottom: 0,
  paddingTop: "46px",
};

export const topSpace: React.CSSProperties = {
  width: "100%",
  height: "46px",
  flex: "46px 0 0",
  borderBottom: "1px solid #333",
  backgroundColor: "rgba(0,0,0,0.1)",
};

export const panelStyle: React.CSSProperties = {
  fontSize: "0.9em",
  height: "100%",
  display: "flex",
  flexDirection: "column",
};

export const sectionStyle: React.CSSProperties = {
  margin: "8px 18px",
  flexBasis: "400px",
  flexGrow: 10,
  flexShrink: 10,
};

export const dividerStyle: React.CSSProperties = {
  flexBasis: "1px",
  flexGrow: 0,
  flexShrink: 0,
  borderBottom: "1px solid #8883",
};
